import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  onFilterMenuCategory,
  onFilterMenuCombo,
  onFilterLoyaltyProducts,
} from "../store/Menu/MenuActions";
import { SORTS } from "../utils/Constants";
import useSearchHook from "./useSearchHook";

const useSortMainHook = () => {
  const dispatch = useDispatch();
  const {
    category,
    comboModified,
    sortedCategoryMenu,
    sortedComboMenu,
    searchPhrase,
    loyaltyMenu,
  } = useSelector((state) => state.menu);

  const { handleComboSearch, handleCategorySearch, handleLoyaltyProductsSearch } = useSearchHook();

  const [FType, setFType] = useState(SORTS.DEFAULT);

  useEffect(() => {
    setFType(SORTS.DEFAULT);
  }, [searchPhrase]);

  const getCategory = () => {
    //deep copy object
    return JSON.parse(JSON.stringify(sortedCategoryMenu));
  };
  const getCombo = () => {
    //deep copy object
    return JSON.parse(JSON.stringify(sortedComboMenu));
  };

  const getDefaultSort = () => {
    const categoryFil = searchPhrase
      ? handleCategorySearch(searchPhrase)
      : category;
    const comboFil = searchPhrase
      ? handleComboSearch(searchPhrase)
      : comboModified;
    const loyaltyFil = searchPhrase
      ? handleLoyaltyProductsSearch(searchPhrase)
      : loyaltyMenu?.eligible_products || [];

    return { categoryFil, comboFil, loyaltyFil };
  };

  const getAZSort = () => {
    //category
    let categoryFil = getCategory();
    categoryFil.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    //combo
    let comboFil = Object.keys(getCombo())
      .sort()
      .reduce(function (result, key) {
        result[key] = sortedComboMenu[key];
        return result;
      }, {});
    //loyalty products
    let loyaltyFil = [...(loyaltyMenu?.eligible_products || [])];
    loyaltyFil.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    return { categoryFil, comboFil, loyaltyFil };
  };

  const getZASort = () => {
    //category
    const categoryFil = getCategory();
    categoryFil.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();
      if (fa < fb) {
        return 1;
      }
      if (fa > fb) {
        return -1;
      }
      return 0;
    });
    //combo
    let comboFil = Object.keys(getCombo())
      .sort()
      .reverse()
      .reduce(function (result, key) {
        result[key] = sortedComboMenu[key];
        return result;
      }, {});
    //loyalty products
    let loyaltyFil = [...(loyaltyMenu?.eligible_products || [])];
    loyaltyFil.sort((a, b) => {
      let fa = a.label.toLowerCase(),
        fb = b.label.toLowerCase();
      if (fa < fb) {
        return 1;
      }
      if (fa > fb) {
        return -1;
      }
      return 0;
    });

    return { categoryFil, comboFil, loyaltyFil };
  };

  const handleFilter = (val) => {
    setFType(val);
    let categoryRes = [];
    if (val === SORTS.DEFAULT) {
      categoryRes = getDefaultSort();
    } else if (val === SORTS.AZ) {
      categoryRes = getAZSort();
    } else if (val === SORTS.ZA) {
      categoryRes = getZASort();
    }
    //
    dispatch(onFilterMenuCategory(categoryRes?.categoryFil));
    dispatch(onFilterMenuCombo(categoryRes?.comboFil));
    dispatch(onFilterLoyaltyProducts(categoryRes?.loyaltyFil));
  };

  return { FType, setFType, handleFilter };
};

export default useSortMainHook;
